export default {
	status: {
		"400": {
			title: "400 Bad Request",
			description: "The server couldn't understand the request due to malformed syntax or invalid data.",
		},
		"401": {
			title: "401 Unauthorized",
			description: "You are not authorized to use this resource. You must provide valid credentials to access content.",
		},
		"403": {
			title: "403 Forbidden",
			description: "You're authenticated, but you don't have permission to perform this action.",
		},
		"404": {
			title: "404 Not Found",
			description: "The requested endpoint or resource doesn't exist.",
		},
		"405": {
			title: "405 Method Not Allowed",
			description: "The endpoint doesn't support the HTTP method you're using (e.g., POST on a GET-only endpoint).",
		},
		"408": {
			title: "408 Request Timeout",
			description: "Your request took too long to send or complete.",
		},
		"409": {
			title: "409 Conflict",
			description: "The request can't be completed due to a resource version conflict or duplicate entry.",
		},
		"413": {
			title: "413 Payload Too Large",
			description: "The uploaded file or request body exceeds server limits.",
		},
		"429": {
			title: "429 Too Many Requests",
			description: "You've sent too many requests in a short period. Please slow down.",
		},
		"500": {
			title: "Internal Server Error",
			description: "The server encountered an error it couldn't handle.",
		},
		"501": {
			title: "501 Not Implemented",
			description: "The server doesn't support the functionality required.",
		},
		"502": {
			title: "502 Bad Gateway",
			description: "The server was acting as a gateway and got an invalid response.",
		},
		"503": {
			title: "Service Unavailable",
			description: "The API is temporarily unavailable (maintenance or high load).",
		},
		"504": {
			title: "504 Gateway Timeout",
			description: "The server was acting as a gateway and didn't receive a timely response.",
		},
	},
};
